// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"73b117db","496":"8d8889c6","647":"5f5163ff"}[chunkId] + ".chunk.js";
};